import { useEffect } from "react";
import { axiosPrivate } from "../services/axios";
import UserAPI from "../services/UserService";
import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const { logout } = useAuth();
  const { localKey_access } = LOCAL_STORAGE_TOKENS;
  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          const accessToken = localStorage.getItem(localKey_access);
          config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401 && !prevRequest.sent) {
          prevRequest.sent = true;
          try {
            const newAccessToken = await refresh();
            prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            return axiosPrivate(prevRequest);
          } catch {
            UserAPI.Logout(false).then(logout);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;

export function isValidResponse(response) {
  return response.status >= 200 && response.status < 300;
}
